
export default function AreaInfoSection() {
  const areas = [
    {
      name: '渋谷区',
      image: 'https://public.readdy.ai/ai/img_res/fec1fa12e04bc645bac6f3b66ac4421f.jpg',
      description: '若者文化の発信地として知られる渋谷区。交通アクセスが良く、商業施設も充実しています。',
      highlights: ['交通利便性抜群', 'ショッピング充実', '文化・エンターテイメント'],
      averagePrice: '平均 6,500万円'
    },
    {
      name: '新宿区',
      image: 'https://readdy.ai/api/search-image?query=Shinjuku%20district%20Tokyo%20with%20skyscrapers%2C%20business%20district%2C%20modern%20urban%20landscape%2C%20office%20buildings%2C%20bustling%20city%20life%2C%20professional%20real%20estate%20photography%2C%20clear%20blue%20sky&width=300&height=200&seq=area2&orientation=landscape',
      description: 'ビジネスの中心地である新宿区。高層ビル群と住宅エリアが共存する魅力的な街です。',
      highlights: ['ビジネス中心地', '交通ハブ', '多様な住環境'],
      averagePrice: '平均 7,200万円'
    },
    {
      name: '港区',
      image: 'https://readdy.ai/api/search-image?query=Minato%20district%20Tokyo%20with%20luxury%20residential%20buildings%2C%20upscale%20neighborhood%2C%20modern%20architecture%2C%20elegant%20cityscape%2C%20high-end%20real%20estate%20area%2C%20professional%20photography&width=300&height=200&seq=area3&orientation=landscape',
      description: '高級住宅街として人気の港区。国際色豊かで洗練された住環境が魅力です。',
      highlights: ['高級住宅街', '国際的環境', '洗練された街並み'],
      averagePrice: '平均 9,800万円'
    },
    {
      name: '世田谷区',
      image: 'https://readdy.ai/api/search-image?query=Setagaya%20district%20Tokyo%20residential%20area%20with%20family%20homes%2C%20quiet%20neighborhood%2C%20green%20spaces%2C%20suburban%20lifestyle%2C%20peaceful%20residential%20streets%2C%20professional%20real%20estate%20photography&width=300&height=200&seq=area4&orientation=landscape',
      description: 'ファミリー層に人気の世田谷区。緑豊かで落ち着いた住環境が特徴です。',
      highlights: ['ファミリー向け', '緑豊かな環境', '教育環境充実'],
      averagePrice: '平均 5,800万円'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            対応エリア情報
          </h2>
          <p className="text-lg text-gray-600">
            各エリアの特徴と魅力をご紹介
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {areas.map((area, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl overflow-hidden hover:shadow-lg transition-shadow cursor-pointer">
              <img
                src={area.image}
                alt={area.name}
                className="w-full h-40 object-cover object-top"
              />
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {area.name}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {area.description}
                </p>
                
                <div className="space-y-2 mb-4">
                  {area.highlights.map((highlight, highlightIndex) => (
                    <div key={highlightIndex} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-blue-600 mr-2"></i>
                      {highlight}
                    </div>
                  ))}
                </div>
                
                <div className="border-t pt-4">
                  <div className="text-lg font-semibold text-blue-600">
                    {area.averagePrice}
                  </div>
                  <div className="text-xs text-gray-500">
                    ※マンション平均価格
                  </div>
                </div>
                
                <button className="mt-4 w-full text-blue-600 font-medium hover:text-blue-700 transition-colors cursor-pointer">
                  エリア詳細を見る <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            その他のエリアもお気軽にご相談ください
          </p>
          <button className="text-blue-600 font-medium hover:text-blue-700 transition-colors cursor-pointer">
            対応エリア一覧を見る <i className="ri-arrow-right-line ml-1"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
